module.exports = __webpack_public_path__ + "img/bfytj.8a3ae214.png";